const alumninetwork_data = {
    alumni2026: [
        {
            "name": "J Hariharan",
            "designation": "Captain",
            "photo": "Hariharan.jpg",
            "linkedin": "https://www.linkedin.com/in/hariharan-j-47aa43244/",
            "email": "jhariharan2004@gmail.com"
        },
        {
            "name": "Afeef Bin Ahamed Ali",
            "designation": "Vice-Captain",
            "photo": "Afeef.jpg",
            "linkedin": "http://linkedin.com/in/afeef-bin-ahamed-ali",
            "email": "afeefahamed22@gmail.com"
        },
        {
            "name": "Adithya Kasal",
            "designation": "EC&P Lead",
            "photo": "Adithya Kasal.jpg",
            "linkedin": "https://www.linkedin.com/in/adithya-kasal-130a5b27b/",
            "email": "adithya.kasal@gmail.com"
        },
        {
            "name": "Krishnapranav",
            "designation": "EC&P Lead",
            "photo": "Krishnapranav.jpg",
            "linkedin": "https://www.linkedin.com/in/krishnapranav2409",
            "email": "krishnapranav.221me227@nitk.edu.in"
        },
        {
            "name": "Chirag Ingle",
            "designation": "Mech Lead",
            "photo": "Chirag.jpg",
            "linkedin": "https://www.linkedin.com/in/chiragingle",
            "email": "chiragingle.221me223@nitk.edu.in"
        },
        {
            "name": "Avadhoot Anant Nadgouda",
            "designation": "Mech Lead",
            "photo": "Anant.jpg",
            "linkedin": "http://linkedin.com/in/avadhoot-nadgouda",
            "email": "avadhoot2003@gmail.com"
        },
        {
            "name": "N Nagabhushanam",
            "designation": "EC&P Team Member",
            "photo": "Bhushan.jpg",
            "linkedin": "https://www.linkedin.com/in/nagabhushanam-at-work/",
            "email": "nnagabhushanam.221cs231@nitk.edu.in"
        },
        {
            "name": "Manas Priye",
            "designation": "Mechanical Team Member",
            "photo": "Manas.jpg",
            "linkedin": "https://www.linkedin.com/in/manas-priye-440a432b8/",
            "email": "manaspriye.221ch027@nitk.edu.in"
        },
        {
            "name": "Apoorva Agrawal",
            "designation": "Support Team Member",
            "photo": "Apoorva.jpg",
            "linkedin": "https://www.linkedin.com/in/apoorva-agrawal-8302b825a/",
            "email": "apoorva.agrawal36@gmail.com"
        },
        {
            "name": "Ashna Sanjay Gaude",
            "designation": "Marketing Lead",
            "photo": "Ashna.jpg",
            "linkedin": "https://www.linkedin.com/in/ashna-gaude",
            "email": "ashnasanjaygaude.221ec112@nitk.edu.in"
        }
    ],
    alumni2025: [
        {
            "name": "Jash Lapsiwala",
            "designation": "Captain",
            "photo": "Jash.jpg",
            "linkedin": "https://www.linkedin.com/in/jashlapsiwala/",
            "email": "lapsiwalajashkumarjanak.211me223@nitk.edu.in"
        },
        {
            "name": "Raghavendra Pandurang Jadhav",
            "designation": "Vice-Captain (Technical)",
            "photo": "Raghavendra.jpg",
            "linkedin": "https://www.linkedin.com/in/raghav515/",
            "email": "rjadhav4103@gmail.com"
        },
        {
            "name": "Dev Goti",
            "designation": "Vice-Captain (Operations)",
            "photo": "Dev Goti.jpg",
            "linkedin": "https://www.linkedin.com/in/dev-goti",
            "email": "devgoti1683@gmail.com"
        },
        {
            "name": "Sai Aswin Madhavan",
            "designation": "EC&P Head",
            "photo": "Sai Aswin.jpg",
            "linkedin": "",
            "email": ""
        },
        {
            "name": "Joel Jojo Painuthara",
            "designation": "EC&P Head",
            "photo": "Joel.jpg",
            "linkedin": "https://www.linkedin.com/in/joeljojop",
            "email": "joeljojop@gmail.com"
        },
        {
            "name": "Harish B",
            "designation": "Mech Head",
            "photo": "Harish.jpg",
            "linkedin": "https://www.linkedin.com/in/harish1212",
            "email": "harishbala1212@gmail.com"
        },
        {
            "name": "Prakhar Goel",
            "designation": "EC&P Team Member",
            "photo": "Prakhar.jpg",
            "linkedin": "",
            "email": ""
        }
    ]
};

export default alumninetwork_data;
